import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging } from '../../actions/log';
import { installSoft } from '../../actions/native';

import { PCStoreJsBridge } from '../../nativeapi';
import styles from './SoftButton.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

export default memo(({ soft, info = {}, logInfo = {} }) => {
  const dispatch = useDispatch();
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装
  const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装

  const logInfoData = useSelector(selectLogInfo);

  const [silentSoft, setSilentSoft] = useState(undefined);
  const [buttonText, setButtonText] = useState('安装');
  const [installed, setInstalled] = useState(null); // uninstall 未安装 installed 已安装

  // 确定按钮的显示文字
  useEffect(() => {
    const target = installedSofts.find(
      soft_ => soft_.softID === soft.softID || soft_.SoftID === soft.softID,
    );
    if (target) {
      setButtonText(info.installedText);
      setInstalled(target);
    } else {
      setButtonText(info.uninstallText);
      setInstalled(null);
    }
  }, [soft, installedSofts, info]);

  const handleInstallSoft = () => {
    if (!soft.softID) {
      return;
    }
    const logParam2 = {
      source: logInfo.source,
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: soft.softID,
      softName: soft.softName,
      softType: '0', // 安卓(1)还是PC(0)应用
      type: 'd', // "u" : 'd' 更新还是下载
      url: soft.downLoadUrl,
    };
    // 当为搜索结果也跳转过来的，带上附加信息
    if (logInfo.isSearch) {
      logParam2.search_type = logInfoData.search_type;
      logParam2.search_word = logInfoData.search_word;
    }
    // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
    if (logInfo.isSearch && (logInfo.search_type === 4 || logInfo.search_type === 5)) {
      logParam2.source_p = logInfo.source_p;
      logParam2.source_pp = logInfo.source_pp;
      logParam2.search_type = logInfo.search_type;
      logParam2.search_word = logInfo.search_word;
    }

    let installparams = null;
    if (isEnabledSilent && silentSoft && silentSoft.softID === soft.softID) {
      installparams = {};
      logParam2.type = 'xd'; // 'xu' : 'xd'; //静默更新 还是静默下载
      if (silentSoft.silentParamDic) {
        installparams.quiet = silentSoft.silentParamDic;
      }
      if (silentSoft.silentDirParamDic) {
        installparams.todir = silentSoft.silentDirParamDic;
      }
    }

    if (!installed) {
      // 按钮点击打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Install',
          label: '',
          param2: logParam2,
          param3: soft.bizInfo || null,
        }),
      );
      const softInfo = { ...soft, logInfo: logParam2, installparams, isClick: 'click' };
      dispatch(installSoft(softInfo));
    } else {
      // 按钮点击打桩
      logParam2.type = 'o';
      dispatch(
        logging({
          category: 'C',
          action: 'Install',
          label: '',
          param2: logParam2,
          param3: soft.bizInfo || null,
        }),
      );
      PCStoreJsBridge.openSoft(installed);
    }
  };

  // 查询是否打开静默安装的开关
  // 查询当前是否已经安装 并且是否可升级
  useEffect(() => {
    if (silentInstSoft && isEnabledSilent) {
      setSilentSoft(silentInstSoft.find(soft_ => soft_.softID === soft.softID));
    }
  }, [soft, silentInstSoft, isEnabledSilent]);

  return (
    <>
      <div
        className={`${installed ? info.installedClassName : info.uninstallClassName} ${
          styles.button
        }`}
        onClick={handleInstallSoft}
      >
        {buttonText}
      </div>
    </>
  );
});
